/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Dialog, FilledButton, Select, Typography } from '@neo4j-ndl/react';
import { useRef, useState } from 'react';

const EXAMPLE_OPTIONS = [
  { label: 'Neo4j', value: 'neo4j' },
  { label: 'Needle 🪡', value: 'needle' },
  { label: 'Graph Databases', value: 'graph-database' },
  { isDisabled: true, label: 'Disabled database option', value: 'disabled' },
];

const Component = (props: React.ComponentProps<typeof Select>) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div
      ref={ref}
      className="n-flex n-flex-col n-items-center n-justify-center n-relative n-h-[500px]"
    >
      <FilledButton size="medium" onClick={() => setIsOpen(true)}>
        Open Dialog
      </FilledButton>
      <Dialog
        container={ref?.current || undefined}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        aria-label="Dialog"
      >
        <Dialog.Header>Using Select inside a dialog</Dialog.Header>
        <Dialog.Description className="n-flex n-flex-col n-gap-token-32">
          <Typography variant="body-medium">
            To use select inside a dialog and avoid the cut-off, you need to use
            the property <code>menuPosition: &quot;fixed&quot;</code> inside the{' '}
            <code>selectProps</code>. This is done automatically if used in a
            Needle Dialog, but can always be overridden manually.
          </Typography>
          <Select
            label="Inside a dialog"
            type="select"
            selectProps={{
              defaultValue: EXAMPLE_OPTIONS[1],
              menuIsOpen: props.selectProps?.menuIsOpen,
              options: EXAMPLE_OPTIONS,
            }}
          />
        </Dialog.Description>
      </Dialog>
    </div>
  );
};

export default Component;
